import React from "react";
import styled from "styled-components";
import { Container } from "semantic-ui-react";
import { useLocation, useRouteMatch } from "react-router-dom";
import { definedFooterRoutes } from "api/api";

interface Props {}

const StyledContainer = styled(Container)`
  flex: 1 0 auto;
`;

const AppDiv = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 80vh;
`;

const fullWidthPages = [
  definedFooterRoutes.forCompanies,
  definedFooterRoutes.forOrganizations,
];

const SmartLayout: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation();
  const match = useRouteMatch("/profesionali/:slug/:subPage?");

  if (new RegExp(fullWidthPages.join("|")).test(pathname) || match?.isExact) {
    return <>{children}</>;
  }

  return (
    <AppDiv>
      <StyledContainer>{children}</StyledContainer>
    </AppDiv>
  );
};

export default SmartLayout;
